import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css']
})
export class SettingsPageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToCrudView(table){
/*     sidenav.toggle(); */
    this.router.navigateByUrl('crud/'+table);
  }

  goBack(){
    window.history.back();
  }
}
